<template>
    <aside
            class="user-banned-modal"
            v-if="showBackdrop"
    >
        <FullBackdrop>
            <div class="dialog">
                <div>
                    <div class="icon">
                        ⚠
                    </div>
                    <h4>
                        {{$t('user_banned.title')}}
                    </h4>
                    <p>
                        {{$t('user_banned.subtitle')}}
                    </p>
                    <p
                            v-if="$cms.stringsReady()"
                            v-html="$cms.string('user_banned.contact_information')"
                    >
                    </p>
                    <p v-else>
                        {{$t('loading')}}
                    </p>
                </div>
                <div class="footer">
                    <button
                            class="btn"
                            type="button"
                            @click="showBackdrop = false"
                    >
                        {{$t('cancel')}}
                    </button>
                </div>
            </div>
        </FullBackdrop>
    </aside>
</template>

<script>
  import Spinner from "./Spinner";
  import FullBackdrop from './FullBackdrop';
  import EventBus from '../eventbus';

  const getDefaultData = function(){
      return {
          showBackdrop: false,
          userBanned: false,
      }
  };

  export default {
      components: {
          Spinner,
          FullBackdrop
      },
      methods: {
          updateShowBackdrop(){
              this.showBackdrop = (
                  this.userBanned ||
                  0
              );
          }
      },
      data: getDefaultData,
      watch: {
          showBackdrop(showBackdrop){
              if(showBackdrop === false){
                  Object.assign(this.$data, getDefaultData())
              }
          },
          userBanned(){
              this.updateShowBackdrop();
          },
      },
      mounted(){
          EventBus.$on('userBanned', () => {
              this.userBanned = true;
          });
      },
  }
</script>

<style scoped lang="scss">
    @import '../styles/variables.scss';

    .dialog{
        .icon{
            font-size: 150px;
            color: $pallete_main_color;
        }

        text-align: center;
        padding: 1.5em;
        width: 100%;
        height: 100%;
        background-color: whitesmoke;
    }

    .footer{
        margin-top: 1em;

        text-align: center;
    }
</style>
